import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

let prevPaddingRight = '0';

function getScrollerWidth() {
  return window.innerWidth - document.body.offsetWidth;
}

export function disableScroll(element) {
  const scrollerWidth = getScrollerWidth();
  prevPaddingRight = document.getElementById('root').style.paddingRight;
  disableBodyScroll(element);
  document.getElementById('root').style.paddingRight = `${scrollerWidth}px`;
}

export function enableScroll(element) {
  enableBodyScroll(element);
  document.getElementById('root').style.paddingRight = `${prevPaddingRight}`;
}

export function clearScrollLocks() {
  clearAllBodyScrollLocks();
  document.getElementById('root').style.paddingRight = `${prevPaddingRight}`;
}
